
const Loading = {};
Loading.install = function (Vue) {
    Vue.mixin({
        created() {
            let that = this;
            const loading = {
                show(msg = '加载中...') {
                    that.$toast.loading({ message: msg, mask: true, duration: 0 });
                },
                hide() {
                    that.$toast.clear();
                },
            }
            this.$loading = loading;
        }
    })

}
export default Loading;